import Vue from 'vue';
import securityService from '../services/securityService'

export default Vue.mixin({
    methods: {
        getFilter(filter) {
            var memberId = securityService.getMemberId();
            var auditorId = securityService.getAuditorId();
            var newFilter = filter ? filter : {};
            if (auditorId) {
                newFilter = { ...filter, auditorId };
            }
            if (memberId) {
                newFilter = { ...filter, memberId };
            }
            return newFilter;
        }
    }
})
